import { Slideout } from '../../../../../ps-aspect-design';
import React from 'react';
import { bool, func } from 'prop-types';
import './DataMethodologySlideout.scss';

DataMethodologySlideout.propTypes = {
  setShowDataMethodologySlideout: func,
  showDataMethodologySlideout: bool
};

function DataMethodologySlideout(props) {
  const { showDataMethodologySlideout, setShowDataMethodologySlideout } = props;

  const renderHeader = <h1>Data Methodology</h1>;

  return (
    <Slideout
      className="data-methodology-slideout"
      header={renderHeader}
      isOpen={showDataMethodologySlideout}
      onClose={setShowDataMethodologySlideout}
      showOverlay
      size="medium"
    >
      <div className="data-methodology-slideout__content">
        <h2 className="content__header">The Data</h2>
        <table className="data-trend__table">
          <thead>
            <tr>
              <td className="row-label__column" />
              <td>Q2 2019</td>
              <td>Q3 2019</td>
              <td className="separator">Q4 2019</td>
              <td>Q1 2020</td>
              <td>Q2 2020</td>
              <td>Q3 2020</td>
              <td className="separator">Q4 2020</td>
              <td>Q1 2021</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="row__label">Number of Metros</td>
              <td>368</td>
              <td>368</td>
              <td>368</td>
              <td>368</td>
              <td>368</td>
              <td>368</td>
              <td>368</td>
              <td>368</td>
            </tr>
            <tr>
              <td className="row__label">Number of Cities</td>
              <td>10,302</td>
              <td>10,302</td>
              <td>10,302</td>
              <td>10,302</td>
              <td>10,302</td>
              <td>10,302</td>
              <td>10,302</td>
              <td>10,302</td>
            </tr>
            <tr>
              <td className="row__label">Total Profiles Analyzed</td>
              <td>259,342</td>
              <td>260,683</td>
              <td>260,274</td>
              <td>228,373</td>
              <td>220,944</td>
              <td>147,539</td>
              <td>186,731</td>
              <td>168,102</td>
            </tr>
          </tbody>
        </table>
        <table className="data-trend__table">
          <thead>
            <tr>
              <td className="row-label__column" />
              <td className="separator">2019</td>
              <td>2020</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="row__label">Number of Metros</td>
              <td>368</td>
              <td>368</td>
            </tr>
            <tr>
              <td className="row__label">Number of Cities</td>
              <td>10,302</td>
              <td>10,302</td>
            </tr>
            <tr>
              <td className="row__label">Total Profiles Analyzed</td>
              <td>1,008,672</td>
              <td>723,316</td>
            </tr>
          </tbody>
        </table>
        <h2 className="process__header">The Process</h2>
        <div className="association__container">
          <h4>Associate</h4>
          <ul className="info__list">
            <li>PayScale’s Crowd-Sourced survey data is associated with a location as well as a job family:</li>
          </ul>
          <div className="data-association-type">
            <div className="locations-info">
              <span className="type__label">Locations:</span> Coverage is based on the US Census Bureau's 392
              Metropolitan and 546 Micropolitan Statistical Areas (MSAs), which are delineated by the{' '}
              <a href="https://www.census.gov/programs-surveys/metro-micro/about.html" target="_blank">
                Office of Management and Budget
              </a>{' '}
              and utilized by the Census.
            </div>
            <div className="job-families-info">
              <span className="type__label">Job Families: </span> Jobs are associated with the Occupation groups
              maintained by the{' '}
              <a href="https://www.bls.gov/ooh/home.htm" target="_blank">
                Bureau of Labor Statistics (BLS)
              </a>
              .
            </div>
          </div>
        </div>
        <div className="data-values-info__container">
          <div className="calculation">
            <h4 className="calculate__header">Calculate</h4>
            <ul className="info__list">
              <li>
                Geographic Differentials represent the ratios of the median salary of people employed in a location over
                the national median salary in the same time window.
              </li>
              <li>
                Weighting and statistical smoothing methodologies are applied, which can balance high coverage with low
                noise and incorporate recent trends.
              </li>
              <li>
                We require a minimum of 75 observations in the previous 12 months to display data for a particular
                location and job family.
              </li>
            </ul>
          </div>
          <div className="validation">
            <h4 className="validate__header">Validate</h4>
            <ul className="info__list">
              <li>
                The Geo Differentials are validated against the Occupational Employment Statistics (OES) data set
                collected and maintained by the BLS.
              </li>
              <li>
                Using wage data collected on a rolling 6-month basis by the BLS, we create location-based differentials
                and compare them to the 397 metropolitan areas available in the BLS data.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Slideout>
  );
}

export default DataMethodologySlideout;
